import { post, fetch, patch, put } from '@/utils/http';
const API_ROOT = process.env.API_ROOT;

async function getCurrentUserInfo() {
    return fetch(`${API_ROOT}/getInfo`);
}

export {
    getCurrentUserInfo,
}


// WEBPACK FOOTER //
// ./src/api/userApi.js